var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"LmVjcmc3dDAgewogIHdpZHRoOiAxNDBweDsKICB0ZXh0LWRlY29yYXRpb246IG5vbmU7CiAgZm9udC1zaXplOiAxMnB4OwogIGNvbG9yOiAjMzMzOwogIGRpc3BsYXk6IGlubGluZS1ibG9jazsKfQouZWNyZzd0MDp2aXNpdGVkIHsKICBjb2xvcjogIzMzMzsKfQouZWNyZzd0MSB7CiAgaGVpZ2h0OiAyNXB4OwogIHdpZHRoOiAyNXB4OwogIGRpc3BsYXk6IGlubGluZS1ibG9jazsKICBwb3NpdGlvbjogcmVsYXRpdmU7CiAgdG9wOiA1cHg7Cn0KLmVjcmc3dDIgewogIGRpc3BsYXk6IGZsZXg7CiAgdGV4dC1hbGlnbjogcmlnaHQ7CiAgcGFkZGluZy1yaWdodDogMTBweDsKICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsKfQouZWNyZzd0MyB7CiAgZmxleDogMC45Owp9\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};